<script>
export default {
  props: ['campaign']
}
</script>

<template>
  <div>
    <img :src="require(`@/assets/images/print_preview/${this.campaign.package.printSize}.jpg`)"/>
  </div>
</template>

<style scoped>
  img {
    max-height: 600px;
  }
</style>